export const HOME = {
  emergentLink: "emergent-link",
  heroTitle: "hero-title",
  heroSubtitle: "hero-subtitle",
  ctaTalkToAva: "cta-talk-to-ava",
  ctaHowItWorks: "cta-how-it-works",
  categoryStrip: "category-strip",
  metricsSection: "metrics-section",
};

export const NAVBAR = {
  logo: "navbar-logo",
  talkToAvaBtn: "navbar-talk-to-ava",
  menuToggle: "navbar-menu-toggle",
};

export const AVA = {
  chatContainer: "ava-chat-container",
  messageInput: "ava-message-input",
  sendButton: "ava-send-button",
  messages: "ava-messages",
  voiceCallBtn: "ava-voice-call-btn",
  callRequestForm: "ava-call-request-form",
  completionScreen: "ava-completion-screen",
  tabOnline: "ava-tab-online",
  tabCall: "ava-tab-call",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  dashboard: "admin-dashboard",
  leadsTable: "admin-leads-table",
  leadRow: "admin-lead-row",
  statsTotal: "admin-stats-total",
  statsQualified: "admin-stats-qualified",
  statsNew: "admin-stats-new",
  exportCsvBtn: "admin-export-csv",
  leadDetailPage: "admin-lead-detail",
  leadStatusSelect: "admin-lead-status-select",
  updateStatusBtn: "admin-update-status-btn",
  addNoteBtn: "admin-add-note-btn",
  noteInput: "admin-note-input",
  vendorsTable: "admin-vendors-table",
  addVendorBtn: "admin-add-vendor-btn",
  webhookForm: "admin-webhook-form",
  metricsTable: "admin-metrics-table",
};
